/**
 * A single label/value row used throughout PropertyDetailsModal and cards.
 */
const PropertyField = ({ label, value, children }) => (
  <div className="property-field" role="group" aria-label={label}>
    <span className="property-label">{label}:</span>
    <span className="property-value">{children ?? value ?? "N/A"}</span>
  </div>
);

export default PropertyField;
